"use strict";

angular.module("core")
.service("EmailInputModalService", function($q, ModalService, gettextCatalog) {
    this.inputEmail = function(title, inputPlaceHolder, defaultEmail) {
        inputPlaceHolder = inputPlaceHolder || gettextCatalog.getString("your@email.com");
        var deferred = $q.defer();

        ModalService.showModal({
            templateUrl: require("./email-input-modal.modal.html"),
            controller: "EmailInputModalController",
            controllerAs: "EmailInputModalCtrl",
            inputs: {
                $attrs: {
                    title: title,
                    inputPlaceHolder: inputPlaceHolder,
                    defaultEmail: defaultEmail
                }
            }
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            modal.close.then(function(email) {
                if (email) {
                    deferred.resolve(email);
                }
                else {
                    deferred.reject();
                }
                modal.element.remove();
            });
        });
        return deferred.promise;
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/email-input-modal/email-input-modal.service.js
// module id = 448
// module chunks = 0